<template>
  <div class="layer survey-layer">
    <div class="layer-container">
      <Button :to="{ path: '/' }" x="right" class="close" @click.native="close"
        >Bezár</Button
      >
      <!--router-link to="/" :class="['close']"><span>Close</span></router-link-->
      <div class="layer-content">
        <!--transition name="fade-custom" mode="out-in">
          <router-view v-slot="{ Component }" :key="$route.fullPath">
            <component :is="Component" />
          </router-view>
        </transition-->
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "Layer",
  components: {
    Button
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$store.commit("setOpenedLayer", false);
      document.documentElement.classList.remove("noscroll");
    }
  },
  mounted() {
    this.$store.commit("setOpenedLayer", true);
    document.documentElement.classList.add("noscroll");
  },
  unmounted() {
    this.close();
  }
};
</script>

<style lang="scss" scoped></style>
